import { fetchWithAuth, getCSRFToken } from '../auth';

// Resolved per request so tests and runtime env overrides are honoured.
const apiUrl = (path) => `${process.env.REACT_APP_ICC_TOOL_API_HOST}${path}`;

const readOpts = () => ({
    headers: { 'X-CSRFToken': getCSRFToken() },
    credentials: 'include',
});

export class MembershipRequestError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

export const flattenMessages = (body) => {
    if (typeof body === 'string') return body;
    if (Array.isArray(body)) return body.map(flattenMessages).join(' ');
    if (body && typeof body === 'object') return Object.values(body).map(flattenMessages).join(' ');
    return '';
};

const ensureOk = async (resp) => {
    if (resp.ok) return resp;
    if (resp.status === 403) {
        throw new MembershipRequestError("You don't have permission to change this team's membership.", 403);
    }
    const body = await resp.json().catch(() => null);
    const message = flattenMessages(body).trim() || `The server returned an error (${resp.status}).`;
    throw new MembershipRequestError(message, resp.status);
};

export const getMembershipErrorMessage = (err) =>
    err instanceof MembershipRequestError
        ? err.message
        : 'Unable to reach the server. Check your connection and try again.';

const getJson = async (path) => (await ensureOk(await fetchWithAuth(apiUrl(path), readOpts()))).json();

export const getAvailableMembers = () => getJson('availablemembers/');

export const getAllMembers = () => getJson('members/');
